/**
 * Transat domain business helpers
 */
import { round_12decimals, respect_2decimalCount } from '~/utils/lib/core/float'
import { MONTH_LIST } from '~/utils/lib/core/datetime'
import { patternFilter } from '~/utils/lib/core/string'
import { always, includes, tryCatch, values } from '~/utils/lib/core/prelude'

/// ==========================================
///   Entities/hFe
/// ==========================================

/**
 * @enum {typeof hFeSocCongesTypeComptage[keyof typeof hFeSocCongesTypeComptage]}
 * @readonly
 * @desc
 *    Readable values of `hFeSocCongesTypeComptage`
 */
export const hFeSocCongesTypeComptage = /** @type {const} */ ({
  OUVRES: 'ouvrés',
  OUVRABLES: 'ouvrables'
})

/// ==========================================
///   Application/Transat/Company/Parameters/Form
/// ==========================================

export const constraints_tCPF = {
  // related to `hFeSocZC_MoisDebutExCg`
  leaveYearStartingMonth: {
    type: 'string'
  },
  // related to `hFeSocZC_BacReportCP`
  withPaidLeaveCarryOver: {
    type: 'boolean'
  },
  // related to `hFeSocZC_BacReportCP`
  leaveCounting: {
    type: 'string', // ie. using `hFeSocCongesTypeComptage`
  },
  // related to `fFeRubDroitCP_Aller`
  paidLeaveAcquisitionCount: {
    type: 'number',
    presence: true
  },
  // related to `fFeRubZS_105`
  rttAcquisitionCount: {
    type: 'number'
  },
  areRttAvailable: {
    type: 'boolean'
  },
}

export const filters_tCPF = {
  leaveYearStartingMonth: [
    (/** @type {any} */ _) => includes(_, values(MONTH_LIST) )
  ],
  paidLeaveAcquisitionCount: [
    patternFilter(/[0-9]|,|\./g),
  ],
  rttAcquisitionCount: [
    patternFilter(/[0-9]|,|\./g),
  ]
}

export const parsers_tCPF = {
  paidLeaveAcquisitionCount: [
    tryCatch(
      round_12decimals,
      always(undefined)
    )
  ],
  rttAcquisitionCount: [
    tryCatch(
      round_12decimals,
      always(undefined)
    ),
  ],
}

/// ==========================================
///   Application/Transat/Collaborator/Parameters/Form
/// ==========================================

export const constraints_tCoPF = {
  // related to `fFeRubZS_105` (although w/ evolved constraints, see below)
  rttAcquisitionCount: {
    type: 'number'
  },
}

export const filters_tCoPF = {
  rttAcquisitionCount: [
    patternFilter(/[0-9]|,|\./g),
  ]
}

export const parsers_tCoPF = {
  rttAcquisitionCount: [
    tryCatch(
      round_12decimals,
      always(undefined)
    ),
  ],
}
/**
 * @desc Only validate non-stricly positive w/ 2dec numbers (`0`, `1.33`, etc.)
 * @type {(_: number|null) => boolean}
 */
export const checkRTTAcquisitionCount_tCoPF = ft => {
  switch (true) {

    case typeof ft === 'number':
      if (ft < 0)
        return false

      try {
        respect_2decimalCount(ft)
      } catch (_) { return false }

      return true

    default:
      return false
  }
}
